const moneda = 'MX';

export default moneda;
